import axios from "axios";
import config from "@/config";
import router from "@/router";

const state = {};

const getters = {
  getConfirmPhone: (state, getters, rootState, rootGetters) => {
    return rootGetters["auth/getConfirmPhone"];
  },
  getConfirmRules: (state, getters, rootState, rootGetters) => {
    return rootGetters["auth/getConfirmRules"];
  },
  getTempPassword: (state, getters, rootState, rootGetters) => {
    return rootGetters["auth/getTempPassword"];
  },
  getTokenAuth: (state, getters, rootState, rootGetters) => {
    return rootGetters["auth/getToken"];
  },
  getRefreshTokenAuth: (state, getters, rootState, rootGetters) => {
    return rootGetters["auth/getRefreshToken"];
  }
};

const actions = {
  sendRequest: ({ dispatch, getters }, data) => {
    return new Promise((resolve, reject) => {
      let postData = {};
      if (!getters.getConfirmPhone) {
        if (router.currentRoute.path !== "/confirm-phone")
          router.push("/confirm-phone").then(() => resolve({ data: "" }));
      } else if (!getters.getConfirmRules) {
        if (router.currentRoute.path !== "/confirm-rules")
          router.push("/confirm-rules").then(() => resolve({ data: "" }));
      } else if (getters.getTempPassword) {
        if (router.currentRoute.path !== "/change-password")
          router.push("/change-password").then(() => resolve({ data: "" }));
      }
      if (data.data !== undefined) postData.data = data.data;
      if (data.filter !== undefined) postData.filter = data.filter;
      if (data.formData !== undefined) {
        postData = data.formData;
        postData.append("token", getters.getTokenAuth);
      } else {
        postData.token = getters.getTokenAuth;
      }
      let axiosParams = {
        url: data.url,
        data: postData,
        method: data.method ?? "POST",
        responseType: data.responseType ?? "json"
      };
      if (data.headers !== undefined) axiosParams.headers = data.headers;
      axios(axiosParams)
        .then(resp => {
          if (resp.data.error) {
            if (resp.data.error === "Expired token") {
              resolve(dispatch("refreshRequest", data));
            } else if (!data.ignoreErrors) {
              alert(resp.data.error);
            }
          } else {
            resolve(resp);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  refreshRequest: ({ commit, dispatch, getters }, data) => {
    return new Promise((resolve, reject) => {
      let postData = {};
      postData.refreshToken = getters.getRefreshTokenAuth;
      axios({
        url: config.backend_url + "users/refresh-login",
        data: postData,
        method: "POST"
      })
        .then(resp => {
          if (resp.data.error === "Expired token") {
            dispatch("auth/authLogout", {}, { root: true });
          } else {
            commit("auth/authSuccess", resp.data, { root: true });
            resolve(dispatch("sendRequest", data));
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
